module.exports = __webpack_public_path__ + "img/cbt_healed.39f76b4a.svg";